import { useEffect, useRef } from "react";
import { shouldIgnoreHotkey } from "@/hooks/use-queue-hotkeys";

export interface LeadHotkeyHandlers {
  /** 1: Ikke svar. */
  onNoAnswer?: () => void;
  /** 2: Ring tilbake senere. */
  onCallBack?: () => void;
  /** 3: Sendt e-post. */
  onEmailSent?: () => void;
  /** 4: Avtalt møte. */
  onBookMeeting?: () => void;
  /** 5: Avvist (VIB-3050). */
  onNotRelevant?: () => void;
  /** 6: Feil nummer. */
  onWrongNumber?: () => void;
  /** S: hopp over. */
  onSkip?: () => void;
}

const KEY_TO_HANDLER: Record<string, keyof LeadHotkeyHandlers> = {
  "1": "onNoAnswer",
  "2": "onCallBack",
  "3": "onEmailSent",
  "4": "onBookMeeting",
  "5": "onNotRelevant",
  "6": "onWrongNumber",
  s: "onSkip",
};

/**
 * Tastatursnarveier for leads-kortet. Samme regler som køen: ingen snarveier mens
 * brukeren skriver, har en dialog åpen eller holder en modifikator.
 */
export function useLeadHotkeys(handlers: LeadHotkeyHandlers, enabled = true): void {
  const ref = useRef(handlers);
  ref.current = handlers;

  useEffect(() => {
    if (!enabled) return;
    const onKeyDown = (event: KeyboardEvent) => {
      if (shouldIgnoreHotkey(event)) return;
      const name = KEY_TO_HANDLER[event.key.toLowerCase()];
      const handler = name ? ref.current[name] : undefined;
      if (!handler) return;
      event.preventDefault();
      handler();
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [enabled]);
}
